import { isMobileWeb } from 'config/isMobileWeb';

import { CONTENT_MIN_REFERENCE_DIMENSION } from '../constants';

export const getIsNarrowMobileWeb = (screenWidth: number): boolean =>
  isMobileWeb && screenWidth < CONTENT_MIN_REFERENCE_DIMENSION;
